export default __webpack_public_path__ + "static/media/member-bg.027214d7.svg";